import { render, staticRenderFns } from "./roleManager.vue?vue&type=template&id=47ca2be5"
import script from "./roleManager.vue?vue&type=script&lang=js"
export * from "./roleManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports